module.exports = __webpack_public_path__ + "img/hall-of-fame_7.98af1844.jpg";